import "@esri/calcite-components/dist/components/calcite-loader";
import { forwardRef, useEffect, useRef, useState } from "react";
import createMapView from "../../tools/createMapView";
import './insetMap.scss';
import { useSelector } from "react-redux";
import Legend from "@arcgis/core/widgets/Legend";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { CalciteLoader } from "@esri/calcite-components-react";

const InsetMap = forwardRef(({ portalId, ...props }, ref) => {
  const mapRef = useRef(null)
  const legendRef = useRef(null)
  const imgRef = useRef(null)
  const [imageSrc, setImgSrc] = useState()
  const [theView, setTheView] = useState(null)


  const viewOpts = useSelector(state => state.viewOpts)
  // console.log('viewOpts', viewOpts)

  // const [isFrozen, setIsFrozen] = useState(true)
  // const [isLoading, setIsLoading] = useState(true)


  // Create the view once when component mounts or portalId changes
  useEffect(() => {
    let freshMapOpts = { ...viewOpts.map, portalItem: { id: portalId } }
    
    // Only pass center/zoom for initial view, not extent
    let initialViewOpts = {
      zoom: viewOpts.zoom,
      center: viewOpts.center
    }

    // ** Create the View
    const view = createMapView(freshMapOpts, initialViewOpts)
    setTheView(view)

    // Cleanup function to destroy the view when component unmounts
    return () => {
      if (view) {
        view.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portalId])

  // Update extent when it becomes available
  useEffect(() => {
    if (theView && viewOpts.extent && viewOpts.extent.xmin !== undefined) {
      theView.extent = viewOpts.extent
    }
  }, [theView, viewOpts.extent])

  useEffect(() => {
    if (!theView) return

    let staticLegend = new Legend({
      view: theView,
      style: {
        type: "card",
        layout: "side-by-side"
      }
    })

    if (legendRef.current && legendRef.current.children.length < 1) {
      staticLegend.container = legendRef.current
    }
  }, [theView])

  useEffect(() => {
    if (!theView) return

    theView.ui.empty('top-left')
    // theView.ui.add(staticLegend, 'top-left')
    // freeze the view
    theView.on('mouse-wheel', (evt) => {
      evt.stopPropagation()
    })


    theView.container = mapRef.current

    reactiveUtils.whenOnce(() => !theView.updating).then(() => {
      // Take a screenshot at the same resolution of the current view
      theView.takeScreenshot().then((screenshot) => {
        // console.log('screenshot', screenshot)
        setImgSrc(screenshot.dataUrl)
      });
    });

    // eslint-disable-next-line
  }, [theView])


  // console.log('legend', legendRef.current.innerHTML)

  return (
    <div ref={ref} className={'inset-map page-break'}>
      <div ref={legendRef}></div>
      <CalciteLoader hidden={!!imageSrc}></CalciteLoader>
      <div style={{ position: 'relative' }}>

        <img style={{ zIndex: 1 }} src={imageSrc} alt='map of new jersey' ref={imgRef} />
        <div style={{
          visibility: 'hidden',
          position: 'absolute', top: '0px', zIndex: 0
        }} className={`live-map print-hidden`} ref={mapRef}></div>
      </div>
    </div>
  );
})
export default InsetMap;
